// js/ischedule/modules/map.js

// Globals
let map;               // Google Map instance
let infoWindow;        // Reusable InfoWindow for markers
const allMarkers = []; // Array to hold all marker objects
  
/**
 * Wait for the Google Maps API to be available, then invoke callback.
 * @param {Function} fn Initialization function
 */
function whenMapsReady(fn) {
  if (window.google && google.maps) {
    fn();
  } else {
    const interval = setInterval(() => {
      if (window.google && google.maps) {
        clearInterval(interval);
        fn();
      }
    }, 100);
  }
}
  
  
/**
 * Initialize the map for iSchedule centers display.
 */
export function initLocationMap() {
  // Check if Google Maps is available and we have locations data
  if (!window.google || !window.google.maps || !window.locationsData) {
    console.warn('Google Maps API or locations data not available');
    return;
  }

  // Create the map, centered on continental US by default
  map = new google.maps.Map(
    document.getElementById('isched-centers-map'),
    {
      center: { lat: 39.5, lng: -98.35 },
      zoom: 4,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    }
  );

  // Prepare a single InfoWindow for marker popups
  infoWindow = new google.maps.InfoWindow();

  // Clear existing markers
  allMarkers.forEach(marker => marker.setMap(null));
  allMarkers.length = 0;

  // Create markers for each location
  window.locationsData.forEach(loc => {
    const marker = new google.maps.Marker({
      position: { lat: loc.lat, lng: loc.lng },
      title: loc.title,
      map: map
    });
    marker.data = loc;                // store location meta on marker
    marker.addListener('click', onMarkerClick);
    allMarkers.push(marker);
  });

  // Auto-fit the map to show all markers
  if (allMarkers.length > 0) {
    const bounds = new google.maps.LatLngBounds();
    allMarkers.forEach(marker => bounds.extend(marker.getPosition()));
    map.fitBounds(bounds);
    
    // Ensure minimum zoom level
    google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
      if (map.getZoom() > 15) {
        map.setZoom(15);
      }
    });
  }
}
  
  
/**
 * Show an InfoWindow with location details when a marker is clicked.
 */
function onMarkerClick() {
  const loc = this.data;
  
  // Format distance text (similar to the main script)
  let distanceText = "";
  if (loc.distance !== undefined && loc.distance !== null) {
    let distance = parseFloat(loc.distance);
    if (!isNaN(distance)) {
      if (distance === 0) {
        distanceText = "<1 mi";
      } else if (distance < 1) {
        distanceText = distance.toFixed(1) + " mi";
      } else {
        distanceText = Math.round(distance) + " mi";
      }
    }
  }
  
  // Get brand image HTML (similar to main script)
  let brandImageHTML = '';
  const pluginUrl = window.ischeduleData?.pluginUrl || '';
  
  if (loc.brand === 'lvi') {
    brandImageHTML = `<img src="${pluginUrl}public/images/lvi-icon.svg?1" alt="Lasik Vision Institute">`;
  } else if (loc.brand === 'lp') {
    brandImageHTML = `<img src="${pluginUrl}public/images/lasikplus-icon.svg?1" alt="LasikPlus">`;
  } else if (loc.brand === 'tlc') {
    brandImageHTML = `<img src="${pluginUrl}public/images/tlc-icon.svg" alt="TLC Vision">`;
  } else if (loc.brand === 'wht') {
    brandImageHTML = `<img src="${pluginUrl}public/images/whiting-logo.svg" alt="Whiting Clinic">`;
  } else {
    brandImageHTML = `<div class="center_brand_text">${loc.brand || 'Vision Center'}</div>`;
  }
  
  const html = `
    <div class="gmap-marker-content isched_centers__list__item__content">
      <div class="isched_centers__list__item__image">
        ${brandImageHTML}
      </div>
      <div class="isched_centers__list__item__name">
        <div class="isched_centers__list__item__name__name">${loc.city}, ${loc.state}</div>
        <div class="isched_centers__list__item__distance">${distanceText}</div>
      </div>
      <div class="isched_centers__list__item__address">${loc.address}, ${loc.city}, ${loc.state} ${loc.zip}</div>
      <div class="isched_centers__list__item__rating">
        ${loc.rating ? `
        <div class="isched_star_rating">
          <div class="isched_star_rating__rating">${loc.rating}</div>
          <div class="isched_star_rating__stars" role="img" aria-label="${loc.rating} star rating"></div>
          ${loc.userRatingsTotal ? `
          <div class="isched_star_rating__reviews_count">${loc.userRatingsTotal} Reviews</div>
          ` : ''}
        </div>
        ` : ''}
      </div>
      <div class="isched_centers__list__item__button">
        <button class="isched-button isched-button--primary center-select-btn" data-center-code="${loc.centerCode}">Select Center</button>
      </div>
    </div>
  `;
  infoWindow.setContent(html);
  infoWindow.open(map, this);
  
  // Add event listener for the select center button after the popup opens
  google.maps.event.addListenerOnce(infoWindow, 'domready', function() {
    const selectBtn = document.querySelector('.gmap-marker-content .center-select-btn');
    if (selectBtn) {
      selectBtn.addEventListener('click', function() {
        const centerCode = this.getAttribute('data-center-code');
        // Trigger the same logic as the list item button click
        if (window.jQuery) {
          window.jQuery('.center-select-btn[data-center-code="' + centerCode + '"]').first().trigger('click');
        }
        // Close the info window
        infoWindow.close();
      });
    }
  });
}
  